import { BRAND_ASSETS_BASE } from '../../constants';

interface BrandProps {
  className?: string;
  collapsed: boolean;
  isAppDev?: boolean;
}

/** Renders the MediaInbox brand image for the current sidebar state. */
export function Brand({ className, collapsed, isAppDev = false }: BrandProps) {
  return (
    <img
      className={className}
      src={
        collapsed
          ? `${BRAND_ASSETS_BASE}/images/brand-mini.png`
          : `${BRAND_ASSETS_BASE}/images/brand.png`
      }
      alt="MediaInbox brand"
      style={isAppDev ? { filter: 'hue-rotate(180deg) saturate(1.5)' } : undefined}
    />
  );
}
